import React from 'react';
import styled from 'styled-components';

export const Eyebrow = styled.p`
  font-family: var(--font-body);
  font-size: var(--fs-eyebrow);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 0.9rem;
`;

const Wrapper = styled.header<{ $align: 'left' | 'center' }>`
  max-width: ${({ $align }) => ($align === 'center' ? '760px' : '720px')};
  margin: ${({ $align }) => ($align === 'center' ? '0 auto' : '0')};
  text-align: ${({ $align }) => $align};
  margin-bottom: clamp(2.25rem, 4vw, 3.5rem);
`;

export const SectionTitle = styled.h2`
  font-size: var(--fs-h2);
  font-weight: 600;
  line-height: 1.12;
  letter-spacing: -0.02em;
`;

const Description = styled.p`
  margin-top: 1rem;
  color: var(--text-2);
  font-size: 1.0625rem;
  line-height: 1.65;

  @media (min-width: 1024px) {
    font-size: 1.125rem;
  }
`;

interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'left' | 'center';
  id?: string;
  as?: 'h1' | 'h2';
  className?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  description,
  align = 'left',
  id,
  as = 'h2',
  className,
}) => (
  <Wrapper $align={align} className={className}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <SectionTitle as={as} id={id}>
      {title}
    </SectionTitle>
    {description && <Description>{description}</Description>}
  </Wrapper>
);

export default SectionHeading;
